import rest from "@/rest-client";
import vuexStore from "@/store/customSaveStore";

export const dataDisposalMethod = vuexStore({
  namespaced: true,
  path: "/data-disposal-method",
  state: {
    editedData: null,
  },
  getters: {
    editedData: (state) => state.editedData,
  },
  mutations: {
    editedData: (state, value) => (state.editedData = value),
  },
  actions: {
    addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        return rest.post("/data-disposal-method", payload);
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});

export const organizationDisposalMethod = vuexStore({
  namespaced: true,
  path: "/disposal-method",
});
